export const OwnerProxyPermissions = {
  VIEW: "view",
  DEVICE_MANAGER: "device_manager",
  ADMINISTRATOR: "administrator",
};

export const OwnerProxyOptions = {
  [OwnerProxyPermissions.VIEW]: null,
  [OwnerProxyPermissions.DEVICE_MANAGER]: ["general-modify"],
  [OwnerProxyPermissions.ADMINISTRATOR]: ["general-modify", "payout-request", "financial"],
};

export const OwnerProxyFeaturePermissions = {
  DEVICE_CHANGE_MODE: ["general-modify"],
  DEVICE_LOAD_BALANCING_CREATE: ["general-modify"],
  DEVICE_LOAD_BALANCING_DELETE: ["general-modify"],
  DEVICE_LOAD_BALANCING_EDIT: ["general-modify"],
  DEVICE_NETWORK_CONFIGURE: ["general-modify"],
  DEVICE_NETWORK_INFO: ["general-modify"],
  DEVICE_NETWORK_REBOOT: ["general-modify"],
  DEVICE_NETWORK_TEST_CONNECTION: ["general-modify"],
  DEVICE_REGISTER: ["general-modify"],
  DEVICE_SET_USER_ACCESS: ["general-modify"],
  GET_STARTED: ["general-modify"],
  PAYMENT_PLAN_CREATE: ["general-modify"],
  PAYMENT_PLAN_EDIT: ["general-modify"],
  SERVICE_SUBSCRIPTION_CONFIGURE: ["general-modify"],
  SERVICE_SUBSCRIPTION_EXTEND: ["general-modify"],
  SERVICE_SUBSCRIPTION_REACTIVATE: ["general-modify"],
  SERVICE_SUBSCRIPTION_SET_AUTO_PAYMENT: ["general-modify"],
  SETTING_CHANGE_PASSWORD: [], // nothing allowed yet
  SETTING_OWNER_PROXY_CREATE: [], // nothing allowed yet
  SETTING_OWNER_PROXY_EDIT: [], // nothing allowed yet
  SETTING_PUBLIC_PROFILE: ["general-modify"],
  SETTING_SETTINGS: ["general-modify"],
  WALLET_CREATE: ["financial"],
  WALLET_EDIT: ["financial"],
  WALLET_TOPUP: ["financial"],
  WALLET_WITHDRAWAL: ["payout-request"],
};
